module.exports = __webpack_public_path__ + "static/media/icon-chat.f3a51f90.svg";